import ToothView from "./ToothView";

export default class GlobalStore {
    public teeth: ToothView[] = []
    constructor() {
        for (let i = 0; i < 32; i++) {
            this.teeth[i] = new ToothView()
        }
    }
}